import { ReactNode } from 'react';
import styled from 'styled-components';
import { Badge, BADGE_VARIANTS } from 'ui/badge';
import { OpenNewWindow16 } from 'ui/icons';
import { spacing, textColors } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { validateUrl } from './utils';
import { SETTINGS_DISPLAY_CONTENT } from '../EditPush/constants';
import { SettingsReadOnlyText } from './EditorContentContainer.styled';

const ReadOnlyWrapper = styled.div`
  display: flex;
  padding-bottom: ${spacing.half};
`;

const ReadOnlyLink = styled.a`
  display: flex;
  align-items: center;
  position: relative;
  gap: ${spacing.eighth};
  margin-left: ${spacing.quarter};
  text-decoration: none;
`;

const LinkContent = styled.span<{ isUnderlined?: boolean }>`
  ${(props) => (props.isUnderlined ? `text-decoration: underline;` : '')}
  color: ${textColors.textLink};
  margin-left: ${spacing.half};
  max-width: ${pxToRem(200)};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const StyledReadOnlyText = styled(SettingsReadOnlyText)`
  padding-left: ${spacing.threeQuarter};
  overflow-wrap: anywhere;
`;

type Props = {
  dataTest: string;
  badgeContent: ReactNode | string;
  link: string;
};

export const InputTextWithBadge = (props: Props) => {
  const { dataTest, badgeContent, link = '' } = props;
  return (
    <ReadOnlyWrapper>
      <Badge variant={BADGE_VARIANTS.INFO}>{badgeContent}</Badge>
      {link === SETTINGS_DISPLAY_CONTENT.unsetText ? (
        <StyledReadOnlyText isUnset={true} data-test="media-url-ro">
          {SETTINGS_DISPLAY_CONTENT.unsetText}
        </StyledReadOnlyText>
      ) : (
        <ReadOnlyLink href={validateUrl(link)} target="_blank" rel="noreferrer noopener">
          <LinkContent data-test={dataTest} isUnderlined={true}>
            {link}
          </LinkContent>
          <OpenNewWindow16 color={textColors.textLink} />
        </ReadOnlyLink>
      )}
    </ReadOnlyWrapper>
  );
};
